export const CATEGORY_ISSUES_MODEL = {
  KEY: 'key',
  URL: 'url',
  TITLE: 'title',
  ASSIGNEE: 'assignee',
  TYPE: {
    NAME: 'issue_type',
    ICON: 'issue_type_icon_url'
  }
};

export const CATEGORY_ISSUES_TABLE_MODEL = {
  TYPE_CELL: 'type_cell',
  KEY_CELL: 'key_cell',
  TITLE_CELL: 'title_cell',
  ASSIGNEE_CELL: 'assignee_cell'
};
